(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wl-flex-logos"] && !Shopify.designMode) return;
  try {
    
(function(){
  let leftNav = document.querySelector('.nav-left');
  let rightNav = document.querySelector('.nav-right');
  let wrapper = document.querySelector('.flex-logo--card-wrapper');

  if (wrapper.scrollWidth > wrapper.offsetWidth && window.innerWidth > 749) {
    document.querySelector(".scroll-nav").style.display = "flex";
  }

  leftNav.onclick = () => { document.querySelector(".flex-logo--card-wrapper").scrollLeft -= 250; };
  rightNav.onclick = () => { document.querySelector(".flex-logo--card-wrapper").scrollLeft += 250; };
  
})();

  } catch(e) { console.error(e); }
})();
})();
